import { Map } from "immutable";

import contactActions from "./actions";

// const initState = new Map({
//   exercises,
//   seectedId: "",
//   editView: false
// });

const initState = {
  exercises: [],
  editView: false,
  showingCreateModal: false,
  selectedExercise: null,
  not_matching_ex_logs: []
};

export default function contactReducer(state = initState, action) {
  // console.log(action.type);
  switch (action.type) {
    case contactActions.CHANGE_CONTACT:
      //return state.set("seectedId", action.id).set("editView", false);
      return {
        ...state,
        tracking_type: action.tracking_type,
        seectedId: action.id,
        editView: false
      };
    case contactActions.ADD_CONTACT:
      return state
        .set("exercises", action.contacts)
        .set("seectedId", action.selectedId)
        .set("editView", true);
    case contactActions.EDIT_CONTACT:
      return state.set("exercises", action.contacts);
    case contactActions.DELETE__CONTACT:
      return state
        .set("exercises", action.contacts)
        .set("seectedId", action.seectedId);
    case contactActions.EDIT_VIEW:
      return {
        ...state,
        editView: action.view
      };
    case "FETCH_EXERCISES_SUCCESS":
      //const streams = action.payload.streams
      return {
        ...state,
        exercises: action.payload.exercises
      };

    case "ADD_EXERCISE":
      let updated = false;
      for (let i = 0; i < state.exercises.length; i++) {
        if (state.exercises[i].id === action.payload.id) {
          state.exercises[i] = action.payload;
        }
        updated = true;
      }
      if (!updated) {
        state.exercises.push(action.payload);
      }
      state.exercises.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      return {
        ...state,
        exercises: [...state.exercises]
      };

    case "REMOVE_EXERCISE":
      return {
        ...state,
        exercises: state.exercises.filter(
          item => item.id != action.payload.exercise_id
        )
      };

    case contactActions.SHOW_CREATE_MODAL:
      return {
        ...state,
        showingCreateModal: true
      };
    case contactActions.HIDE_CREATE_MODAL:
      return {
        ...state,
        showingCreateModal: false
      };
    case contactActions.ACTIVATE_EXERCISE:
      return { ...state, selectedExercise: action.payload };
    case contactActions.DEACTIVATE_EXERCISE:
      return { ...state, selectedExercise: null };
    case "NOT_MATCHING_EX_LOGS_LOAD":
      return { ...state, not_matching_ex_logs: action.payload };
    case contactActions.DELETE_EXERCISE:
      return {
        ...state,
        exercises: state.exercises.filter(e => e.id !== action.payload.id),
        selectedExercise: null
      };
    case contactActions.PATCH_EXERCISE:
      let newex = action.payload;
      let exercises = [...state.exercises];
      exercises = exercises.filter(e => e.id !== newex.id);
      exercises.push(newex);
      exercises.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );
      return {
        ...state,
        exercises,
        selectedExercise: action.payload
      };
    default:
      return state;
  }
}

// export { exercises };
